import { render } from "./SideBar.vue?vue&type=template&id=5a7acee2&scoped=true&ts=true&lang=pug"
import script from "./SideBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideBar.vue?vue&type=script&lang=ts&setup=true"

import "./SideBar.vue?vue&type=style&index=0&id=5a7acee2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7acee2"]])

export default __exports__